export const siteInfo = {
  name: "91视频网站",
  tagline: "海量视频免费在线观看，高清流畅不卡顿",
  description: "91视频网站提供海量视频免费在线观看，涵盖电影、电视剧、综艺、动漫、纪录片等，高清流畅不卡顿，每日更新。",
  url: "https://www.91video.com",
  logo: "91视频",
  founded: "2018",
  email: "contact@91video.com",
  phone: "400-888-9191",
  address: "北京市朝阳区建国路88号SOHO现代城A座15层",
  socialLinks: {
    weibo: "https://weibo.com/91video",
    wechat: "91video_official",
    qq: "https://v.qq.com",
  },
  stats: {
    totalVideos: "500000+",
    dailyVisitors: "2000万+",
    registeredUsers: "8000万+",
    totalCategories: "30+",
  },
};